function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller } from 'react-hook-form';
import { TextButton } from 'seagull';
import OTPField from "../../pages/unAuthorizedPages/LoginScreen/Steps/OTPField";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import styles from "./ChangeEmailAddress.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OTPInputSection = _ref => {
  let {
    isLoading,
    control,
    resendCode
  } = _ref;
  const errorMessage = 'Code is invalid. Please try again.';
  return /*#__PURE__*/_jsxs("div", {
    className: styles.sixDigitCodeInput,
    "data-testid": "one-time-password-section",
    children: [/*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "otp",
      rules: {
        required: errorMessage,
        minLength: {
          value: 6,
          message: errorMessage
        }
      },
      render: renderProps => /*#__PURE__*/_jsx(OTPField, _objectSpread(_objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), renderProps.field), {}, {
        testid: "one-time-password",
        autoFocus: true,
        width: 360,
        isLoading: isLoading
      }))
    }), /*#__PURE__*/_jsx(TextButton, {
      type: "button",
      "data-testid": "resend-code-button",
      onClick: resendCode,
      children: "Resend code"
    })]
  });
};
export default OTPInputSection;